import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'gatsby';
import debounce from 'lodash/debounce';

import MobileMenu from './MobileMenu';
import Title from './Title';
import media from '../utils/breakpoints';
import swatches from '../utils/swatches';

const Anchor = styled(Link)`
  transition: color 0.2s;
  transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
  color: ${swatches.slate};
  text-decoration: inherit;
  &:hover {
    color: ${swatches.red};
  }
  &.active {
    text-decoration: underline;
    cursor: default;
    &:hover {
      color: currentColor;
    }
  }
`;

const HeaderStyled =  styled.header`
  height: 60px;
  width: 100%;
  position: fixed;
  background: ${swatches.white};
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: 0;
  box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.05);

  > h1, ul {
    margin: 0;
  }

  .title {
    display: flex;
    align-items: center;
    p {
      ${media.mobile` display: block; `}
      display: none;
      text-transform: uppercase;
      margin: 0;
      margin-left: 20px;
      font-size: 0.7rem;
      font-weight: 700;
      color: #BFD556;
    }
  }
  > ul {
    ${media.desktop`
      display: block;
    `}
    display: none;
    list-style: none;
    padding-inline-start: 0;
    li {
      display: inline;
      margin: 0 20px;
    }
  }
`;

const Button = styled(Link)`
  ${media.desktop` display: block; `}
  display: none;
  background: ${swatches.red};
  color: white;
  border: none;
  border-bottom: 2px solid #CF4A3A;
  padding: 10px 20px;
  cursor: pointer;
  transition: 0.2s;
  text-decoration: unset;
  &:active {
    transform: translateY(1px);
    border: 0;
  }
`;

const Hamburger = styled.button`
  ${media.desktop` display: none; `}
  display: block;
  background: transparent;
  cursor: pointer;
  border: none;
  width: 40px;
  height: 40px;
  position: relative;
  span {
    transition: 200ms;
    width: 23px;
    height: 3px;
    display: block;
    background: ${swatches.slate};
    position: absolute;
    &:first-child {
      top: calc(50% - 8px);
    }
    &:last-child {
      top: calc(50% + 8px);
    }
    ${p => p.active && css`
      &:first-child {
        left: 8px;
        top: 50%;
        transform: rotate(45deg);
        width: 15px;
      }
      &:nth-child(2) {
        display: none;
      }
      &:last-child {
        transform: rotate(-45deg);
        top: 50%;
        right: 8px;
        width: 15px;
      }
    `}
  }
  &:hover {
    span:nth-child(2) {
      width: 15px;
    }
  }
`;

export default class Header extends Component {

  state = {
    showMobileMenu: false,
  }

  mobileMenuHandler = debounce(() => {
    const { showMobileMenu } = this.state;
    console.log("trigger")
    this.setState({ showMobileMenu: !showMobileMenu });
  }, 100, false, { leading: true });

  render() {
    const { showMobileMenu } = this.state;
    return (
      <HeaderStyled>
        <div className="title">
          <Title><Link to="/">Health Farm</Link></Title>
          <p>Just <br/>the good <br/>stuff</p>
        </div>
        <ul>
          <li>
            <Anchor 
              to="/weekly-email/" 
              activeClassName="active"
            >
              Weekly Email
            </Anchor>
          </li>
          <li>
            <Anchor 
              to="/news/"
              activeClassName="active"
            >
              News
            </Anchor>
          </li>
          <li>
            <Anchor 
              to="/search"
              activeClassName="active"
            >
              Search
            </Anchor>
          </li>
          <li>
            <Anchor 
              to="/about/"
              activeClassName="active"
            >
              About
            </Anchor>
          </li>
        </ul>
        <Button to="/">Subscribe</Button>
        <Hamburger 
          aria-label="menu"
          role="presentation"
          active={showMobileMenu}
          onClick={this.mobileMenuHandler} 
        >
          <span></span>
          <span></span>
          <span></span>
        </Hamburger>
        <MobileMenu 
          active={showMobileMenu}
          exit={this.mobileMenuHandler}
        >
          <ul>
            <li>
              <Link 
                to="/weekly-email/"
                activeClassName="active"
              >
                Weekly Email
              </Link>
            </li>
            <li>
              <Link 
                to="/news/"
                activeClassName="active"
              >
                News
              </Link>
            </li>
            <li>
              <Anchor 
                to="/search"
                activeClassName="active"
              >
                Search
              </Anchor>
            </li>
            <li>
              <Link 
                to="/about/"
                activeClassName="active"
              >
                About
              </Link>
            </li>
          </ul>
        </MobileMenu>
      </HeaderStyled>
    );
  }
}